var A = /* @__PURE__ */ ((D) => (D.Docx = ".docx", D.Doc = ".doc", D.Ttf = ".ttf", D.AD_PRT = ".AD_PRT", D.AD_SMP = ".AD_SMP", D.AD_ASM = ".AD_ASM", D.AD_DRW = ".AD_DRW", D))(A || {});
export {
  A as FileExtensionEnum
};
